export function getAppVersion () {
  return process.env.REACT_APP_CAMAS_VERSION || 'N/A'
}

export const frontendBuildHttpHeader = 'Camas-Frontend-Build'
